<template>
  <b-form-group
    v-if="label"
    :label="label">
    <b-input-group>
      <b-form-input
        ref="input"
        v-model="colorValue"
        type="text"
        v-bind="$attrs"
        class="color-input"
        placeholder="Enter color..."
        @input="updateFromInput" />
      <b-input-group-append>
        <span
          :style="{'background-color': colorValue, 'border-radius': '0px 4px 4px 0px'}"
          class="current-color border" />
      </b-input-group-append>
    </b-input-group>
  </b-form-group>
</template>

<script>
export default {
    name: "FormColorPicker",
    inheritAttrs: false,
    props: {
        value: {
            type: String,
            default: () => '',
        },
        label: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            colors: {
                hex: '#000000',
            },
            defaultColor: '#FF0000',
        }
    },
  computed: {
    colorValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
  },
    watch: {
        colorValue(val) {
            if(val) {
                this.updateColors(val)
                this.$emit('input', val)
                //document.body.style.background = val;
            }
        },
    },
    methods: {
        setColor(color) {
            this.updateColors(color)
            this.colorValue = color
        },

        updateColors(color) {
            if(color.slice(0, 1) === '#') {
                this.colors = {
                    hex: color,
                }
            }
            else if(color.slice(0, 4) === 'rgba') {
                let rgba = color.replace(/^rgba?\(|\s+|\)$/g,'').split(','),
                    hex = '#' + ((1 << 24) + (parseInt(rgba[0]) << 16) + (parseInt(rgba[1]) << 8) + parseInt(rgba[2])).toString(16).slice(1)
                this.colors = {
                    hex: hex,
                    a: rgba[3],
                }
            }
        },
        updateFromInput() {
            this.updateColors(this.colorValue)
        },
    },
}
</script>


<style>
    .color-input{
        padding: .5rem;
        line-height: 1.5;
        display: block;
        width: 100%;
        border-width: 1px;
        color: #3d4852;
        background-color: #fff;
        border-radius: .25rem;
        text-align: left;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        position: relative;
    }
    .color-picker{
        position: relative;
        display: flex;
        width: 100%;
    }
    .current-color {
        display: inline-block;
        width: 38px;
        height: 38px;
        background-color: #000;
    }
</style>
